import styled from 'styled-components'

export const BoardContainer = styled.div<{ componentStyle?: string }>`
    ${(props) => props.componentStyle}
    display: grid;
    background-color: --dashboard-basic-background-color;
`

export const TopCards = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
`

export const ChartContainer = styled.div`
    margin-top: 15px;
`

export const BottomCards = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(200px, 1fr));
    gap: 10px;
    text-transform: capitalize;
`

export const MonthlyTitle = styled.div`
    margin: 0;
    padding: 10px 0 10px 0;
    ${({ theme }) => theme.fonts.Karla['s20-ln26-fw800']};
`
